import LoadingOutlined from '../loadingOutlined';
import ToolTip from '../toolTip';


export default function Index(props: {
    price: string,
    unit?: string,
    icon: any,
    tips?: string,
    remark: string,
    spin?: boolean
}) {
    return <div className="Item">
        <div className="item-head">
            <div>
                <div className="price">  <LoadingOutlined spin={props.spin}>{props.price}</LoadingOutlined> </div>
                <div className="unit">{props.unit}</div>
            </div>
            <img src={props.icon} className='icon' />
        </div>
        <div className='item-body'>
            {props.remark}  {props.tips && <ToolTip title={props.tips} />}
        </div>
    </div>
}